<div class="vtr-widget-powered-by-info d-flex justify-content-between align-items-center flex-wrap pb-40 pt-4">
	<div>
		<p class="subTitle mb-0" [innerHTML]="title | translate"></p>
		<p class="text-regular"
			*vtrTranslate="detail | translate">
			<a id="{{linkId}}-privacypolicy"
				[href]="privacyUrl"
				target="_blank"></a>
			<a id="{{linkId}}-termsofservices"
				[href]="termsUrl"
				target="_blank"></a>
		</p>
	</div>
	<div>
		<img class="product-logo"
			[src]=" imgUrl | svgInline | async" />
	</div>
</div>
